export const listReport = {
  table: {
    date: 'Date',
    total: 'Total',
    reset: 'Reset',
    export: 'Export',
    hour: '(unit　ｈ)',
  },
  pageHeader: {
    title: 'Client Device',
  },
  filter: {
    filterDay: 'View by date',
    filterByRangeDay: 'View by range date',
    filterByTime: 'View by specifying period',
  },
  hooks: {
    selectRangeDateFail: 'Range date invalid',
  },
}
